import { render, staticRenderFns } from "./templateWrapper.vue?vue&type=template&id=2fc2ab00"
import script from "./templateWrapper.vue?vue&type=script&lang=js"
export * from "./templateWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports